
import { defineComponent, PropType } from 'vue'
import { iOlapCrossNavigationParameter } from '../Olap'
import Message from 'primevue/message'
import olapCrossNavigationDefinitionDialogDescriptor from './OlapCrossNavigationDefinitionDialogDescriptor.json'

export default defineComponent({
    name: 'olap-cross-navigation-step-two',
    components: { Message },
    props: { propSelectedParameter: { type: Object as PropType<iOlapCrossNavigationParameter | null> }, cell: { type: Object } },
    emits: ['selectFromTable'],
    data() {
        return {
            olapCrossNavigationDefinitionDialogDescriptor,
            selectedParameter: {} as iOlapCrossNavigationParameter,
            value: '',
            nameTouched: false
        }
    },
    watch: {
        propSelectedParameter() {
            this.loadSelectedParameter()
        },
        cell() {
            this.loadValueFromCell()
        }
    },
    created() {
        this.loadSelectedParameter()
        this.loadValueFromCell()
    },
    methods: {
        loadSelectedParameter() {
            this.selectedParameter = this.propSelectedParameter ?? ({} as iOlapCrossNavigationParameter)
            if (this.selectedParameter.name) {
                this.selectedParameter.value = this.selectedParameter.type === 'From Cell' ? `dimension=${this.selectedParameter.dimension} hierarchy=${this.selectedParameter.hierarchy} level=${this.selectedParameter.level}` : (this.selectedParameter.uniqueName as string)
            } else {
                this.selectedParameter.value = ''
            }
        },
        selectFromTable() {
            this.$emit('selectFromTable')
        },
        loadValueFromCell() {
            if (this.cell) {
                this.selectedParameter.value = this.selectedParameter.type === 'From Cell' ? `dimension=${this.cell.dimensionuniquename} hierarchy=${this.cell.hierarchyuniquename} level=${this.cell.level}` : this.cell.level
            }
        }
    }
})
